import React from 'react';
import img from '../../../assets/icons/payment-logos/credit-card.svg'
const CreditCard = () => {
  return (
    <img src={img} alt="/" />
  );
}

export default CreditCard;
